import React, { useState, useRef, useEffect } from "react";
import "./SignInFaceRecognition.css";
import FaceRecognition from "../../FaceRecognition/FaceRecognition";
import { getToken, getUserId } from "../../../api/index";
import { useNavigate } from "react-router-dom";
import { getRedirectPath, clearRedirectPath } from "../../../utils/authRedirect";

function SignInFaceRecognition() {
    const navigate = useNavigate();
    useEffect(() => {
        if(getToken() && getUserId()){
            const target = getRedirectPath();
            clearRedirectPath();
            navigate(target, { replace: true });
        }
    }, []);
    
    return (
        <div className="SignInFaceRecognition">
            <div className="signInFaceRecognitionContainer">
                <div className="faceRecognitionHeader">
                    <button 
                        type="button" 
                        className="authBackHubBtn" 
                        onClick={() => navigate('/')}
                        title="Return to Amalgamate Home"
                        style={{ marginBottom: '12px' }}
                    >
                        ← Back to Hub
                    </button>
                    <div
                        onClick={() => navigate('/')}
                        style={{ cursor: 'pointer', display: 'flex' }}
                        title="Return to Amalgamate Home"
                    >
                        <img
                            className="faceRecognitionHeaderLogo"
                            src="/Assets/LandingPage/AmalgamateLogo.svg"
                            alt="Amalgamate Logo"
                        />
                    </div>
                </div>
                <div className="faceRecognitionContentContainer">
                    <div className="faceRecognitionContent">
                        <div className="faceRecognitionHeaderContainer">
                            <span className="signInText">Face Recognition</span>
                            <span className="signInText2">Please look into the camera and hold still</span>
                        </div>
                        <FaceRecognition isSignIn={true} isUserVerified={'verified'} />

                        <div className="faceRecognitionFooterContainer">
                            <span className="signInText">Live human Recognized</span>
                            <span className="signInText2">Smile & blink your eyes, then move your head slowly to complete the process.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SignInFaceRecognition;
